import { IAsyncActionCallback } from '@state/types';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types'; 

export const duplicateDesign = (duplicateDesignInfo: actionsInterfaces.DuplicateDesignInfo, callback?: (result: any, error: any) => void): actionsInterfaces.IDuplicateDesignAction => {
  return {
    type: actionsTypes.DUPLICATE_DESIGN,
    duplicateDesignInfo,
    callback
  };
};

export const createFromTemplate = (designRequest: actionsInterfaces.ICreateFromTemplate, callback: (result: any, error: any) => void): actionsInterfaces.ICreateFromTemplateAction => {
  return {
    type: actionsTypes.CREATE_FROM_TEMPLATE,
    designRequest,
    callback
  }
}

export const createTemplateFromDesign = (createTemplateFromDesignInfo: actionsInterfaces.CreateTemplateFromDesignInfo, callback?: (result: any, error: any) => void): actionsInterfaces.ICreateTemplateFromDesignAction => {
  return {
    type: actionsTypes.CREATE_TEMPLATE_FROM_DESIGN,
    createTemplateFromDesignInfo,
    callback
  };
};

export const fetchDesigns = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDesignsAction => {
  return {
    type: actionsTypes.FETCH_DESIGNS,
    query,
    callback
  };
};

export const addDesign = (design: actionsInterfaces.IDesign, callback: IAsyncActionCallback): actionsInterfaces.IPostDesignAction => {
  return {
    type: actionsTypes.ADD_DESIGN,
    design,
    callback
  };  
};

export const setDesigns = (designs: actionsInterfaces.IDesign): actionsInterfaces.ISetDesignsAction => {
  return {
    type: actionsTypes.SET_DESIGN,
    designs,
  };
};

export const getDesign = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDesignAction => {
  return {
    type: actionsTypes.GET_DESIGN_INFO,
    query,
    callback
  };  
};

export const getDesignAuth = (id: string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDesignAuthAction => {
  return {
    type: actionsTypes.GET_DESIGN_AUTH,
    id,
    callback
  };  
};

export const setDesign = (design: actionsInterfaces.IDesign): actionsInterfaces.ISetDesignAction => {
  return {
    type: actionsTypes.SET_DESIGN_INFO,
    design,
  };
};

export const setDesignAuth = (designAuth: actionsInterfaces.IDesignAuth, designAuthMailErrors?: string[]): actionsInterfaces.ISetDesignActionAuth => {
  return {
    type: actionsTypes.SET_DESIGN_AUTH,
    designAuth,
    designAuthMailErrors,
  };
};

export const addSuccessDesign = (designResponse: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS_DESIGN,
    designResponse,
  };
};

export const fetchSearchDesigns = (query?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchSearchAction => {
  return {
    type: actionsTypes.FETCH_SEARCH_DESIGNS,
    query,
    callback
  };
};

export const setSearchDesigns  = (designSearches: actionsInterfaces.IDesign): actionsInterfaces.ISetSearchAction => {
  return {
    type: actionsTypes.SET_SEARCH_DESIGN,
    designSearches,
  };
};

export const updateDesign = (design: actionsInterfaces.IDesign, location:string, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateDesignAction => {
  return {
    type: actionsTypes.UPDATE_DESIGN,
    design,
    location,
    callback
  };
};

export const updateDesigndelete = (design: actionsInterfaces.IDesign, location:string, updateFolderCounter?: boolean, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateDesignDeleteAction => {
  return {
    type: actionsTypes.UPDATE_DESIGN_DELETE,
    design,
    location,
    updateFolderCounter,
    callback
  };
};

export const updateDesignAuth = (designAuth: actionsInterfaces.IDesignAuth, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateDesignAuthAction => {
  return {
    type: actionsTypes.UPDATE_DESIGN_AUTH,
    designAuth,
    callback
  };
};

export const requestAccess = (designAccess: actionsInterfaces.IRequestAccess, callback?: (result: any, error: any) => void): actionsInterfaces.IRequestAccessAction => {
  return {
    type: actionsTypes.REQUEST_ACCESS,
    designAccess,
    callback
  };
};

export const fetchDesignCounters = (userEmail: string, sharedFiles: boolean, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchDesignCountersAction => {
  return {
    type: actionsTypes.FETCH_DESIGN_COUNTERS,
    userEmail,
    sharedFiles,
    callback
  };
};

export const setCounterSharedFiles = (counterSharedFiles: actionsInterfaces.IDesign): actionsInterfaces.ISetCounterSharedFilesAction => {
  return {
    type: actionsTypes.SET_COUNTER_SHARED_FILES,
    counterSharedFiles,
  };
};


export const addDesignSuccessFavorite = (designFavoriteResponse: {})=> {
  return {
    type: actionsTypes.ADD_SUCCESS_FAVORITE,
    designFavoriteResponse,
  };
};

export const updateDesigns = (designs: actionsInterfaces.IDesign[], callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateDesignsAction => {
  return {
    type: actionsTypes.UPDATE_DESIGNS,
    designs,
    callback
  };
};

export const updateDesignsFields = (updateInfo:actionsInterfaces.UpdateInfo, callback?: (result: any, error: any) => void): actionsInterfaces.IUpdateDesignsFieldsAction => {
  return {
    type: actionsTypes.UPDATE_DESIGNS_FIELDS,
    updateInfo,
    callback
  };
};

export const fetchCounterDesigns = (filter?:string, callback?: (result: any, error: any) => void): actionsInterfaces.IFetchCounterAction => {
  return {
    type: actionsTypes.FETCH_COUNTER_DESIGNS,
    filter,
    callback
  };
};

export const setCounterDesigns = (counterDesigns: actionsInterfaces.IDesign): actionsInterfaces.ISetCounterAction => {
  return {
    type: actionsTypes.SET_COUNTER_DESIGNS,
    counterDesigns,
  };
};

